import { CLUBHOUSES } from '@/lib/reference/clubhouse';
import { ClubhouseCard } from '@/components/food/ClubhouseCard';

export function FoodTab() {
  return (
    <div className="space-y-3.5 pt-4">
      <div className="rounded-[14px] border border-line bg-paper p-4 shadow-bt">
        <div className="font-serif text-xl font-bold tracking-[-0.01em] text-ink">Pick a Clubhouse</div>
        <p className="mt-1 text-sm leading-relaxed text-ink-soft">
          Browse menus, see hours, dress codes, and tap to call the kitchen directly.
        </p>
      </div>
      {CLUBHOUSES.map((club) => (
        <ClubhouseCard key={club.id} club={club} />
      ))}
      <p className="px-2 text-[11px] leading-relaxed text-mute">
        Menu items shown are illustrative. Confirm pricing and daily specials when you call. The kitchens prefer phone orders for accuracy and pickup timing.
      </p>
    </div>
  );
}
